import React from "react";
import ReactECharts from "echarts-for-react";

const PieChart = ({ chart }) => {

  const option = {

    tooltip: {
      trigger: "item",
    },

    legend: {
      bottom: 0,
    },

    series: [
      {
        type: "pie",

        radius: ["45%", "70%"],

        data: chart.data,

        label: {
          formatter: "{b}\n{d}%",
        },
      },
    ],
  };

  return (
    <ReactECharts
      option={option}
      style={{ height: 350 }}
    />
  );
};

export default PieChart;